import type { QueryResult } from '@apollo/client';
import { useQuery } from '@apollo/client';

import {
  PremiumFeaturesOverviewProducts,
  PremiumPlatform,
} from '@xing-com/crate-common-graphql-types';

import { PremiumFeaturesOverviewDocument } from '../graphql/get-premium-features-overview-query.gql-types';

export const useProJobsData = (): QueryResult => {
  return useQuery(PremiumFeaturesOverviewDocument, {
    variables: {
      platform: PremiumPlatform.Web,
      product: PremiumFeaturesOverviewProducts.Projobs,
    },
    errorPolicy: 'all',
  });
};
